var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 513,
    viewBox: "0 0 279 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.39 355.39C193.155 355.39 235.93 312.615 235.93 259.85C235.93 207.085 193.155 164.31 140.39 164.31C87.6248 164.31 44.8501 207.085 44.8501 259.85C44.8501 312.615 87.6248 355.39 140.39 355.39Z",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1802 259.93L127.02 290.11L184.29 228.95",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.4 341.14V481.97C276.4 497.64 263.58 510.46 247.91 510.46H30.99C15.32 510.46 2.5 497.64 2.5 481.97V30.99C2.5 15.32 15.32 2.5 30.99 2.5H247.91C263.58 2.5 276.4 15.32 276.4 30.99V341.14Z",
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.27 19.9299H97.1299C90.9388 19.9299 85.9199 24.9466 85.9199 31.1349C85.9199 37.3233 90.9388 42.3399 97.1299 42.3399H184.27C190.461 42.3399 195.48 37.3233 195.48 31.1349C195.48 24.9466 190.461 19.9299 184.27 19.9299Z",
    fill: "#ffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 278.9,
    height: 512.97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.387abc9734109ff2c5609e4de935dd76.svg";
export { ForwardRef as ReactComponent };